// Centralized layout constants and utilities
import { createDefaultTheme } from '@stvgroup/stv-ui-components'

// Create default theme to access breakpoint values
const defaultTheme = createDefaultTheme()

// Derive breakpoints from MUI theme to ensure consistency
export const BREAKPOINTS = {
  xs: defaultTheme.breakpoints.values.xs,
  sm: defaultTheme.breakpoints.values.sm,
  md: defaultTheme.breakpoints.values.md,
  lg: defaultTheme.breakpoints.values.lg,
  xl: defaultTheme.breakpoints.values.xl,
}

export const PADDING = {
  xs: '16px',
  sm: '20px',
  md: '24px',
  lg: '48px',
  xl: '64px',
}

// Responsive spacing utility (matches padding values, can be used for any CSS property)
export const responsiveGlobalPadding = {
  xs: PADDING.xs,
  sm: PADDING.sm,
  md: PADDING.md,
  lg: PADDING.lg,
  xl: PADDING.xl,
}

// Simple function to get padding value for a specific breakpoint
export const getPadding = (breakpoint = 'xs') => PADDING[breakpoint] || PADDING.xs
